import { useRemoveDiscountMutation } from '@/src/api/rtkQuery/couponApi'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'
import CouponExpiryModal from './couponExpiryModal'

const CouponExpiryModalWrapper = ({
    setShowCouponExpiry,
    handlePrePayment
}: {
    setShowCouponExpiry: (showCouponExpiry: boolean) => void
    handlePrePayment: () => void
}) => {
    const t = useTranslations('itineraryPage.couponExpiryModal')
    const [removeDiscount] = useRemoveDiscountMutation()
    const itineraryId = useGetItineraryId()

    const onPrimaryClick = () => {
        handlePrePayment()
        setShowCouponExpiry(false)
    }
    const onSecondaryClick = () => {
        setShowCouponExpiry(false)
    }

    const primaryText = t('primaryText')
    const secondaryText = t('secondaryText')
    const secondaryCTA = t('secondaryCTA')
    const primaryCTA = t('primaryCTA')

    useEffect(() => {
        removeDiscount({
            itineraryId,
            payload: { remove: ['COUPON'] }
        })
    }, [])
    return (
        <CouponExpiryModal
            primaryText={primaryText}
            secondaryText={secondaryText}
            primaryCTA={primaryCTA}
            onPrimaryClick={onPrimaryClick}
            secondaryCTA={secondaryCTA}
            onSecondaryClick={onSecondaryClick}
        />
    )
}

export default CouponExpiryModalWrapper
